import _get from "lodash/get";
import { FORM_ID, MaybeEmpty } from "../../../../constants";
import { Form, RootState } from "../../../../models";
import { TeliaPlayState } from "../../../../models/state/teliaPlay";

export const getTeliaPlayData = (state: RootState): MaybeEmpty<TeliaPlayState> => _get(state, "teliaPlay", {});

export const isBroadbandCustomer = (state: RootState): boolean => state.teliaPlay?.isBroadbandCustomer === true;

export const getAvailableAddresses = (state: RootState): TeliaPlayState["availableAddresses"] | undefined =>
    getTeliaPlayData(state)?.availableAddresses;
export const getAddressVaid = (state: RootState): TeliaPlayState["vaidFromAddress"] | undefined =>
    getTeliaPlayData(state)?.vaidFromAddress;
export const getSelectedPackage = (state: RootState): TeliaPlayState["selectedPackage"] | undefined =>
    getTeliaPlayData(state)?.selectedPackage;
export const getSelectedPackageId = (state: RootState): number | undefined => getSelectedPackage(state)?.id;
export const getFormById = (state: RootState, id: typeof FORM_ID.PERSONAL_DETAILS_TELIA_PLAY): Form =>
    _get(state, ["teliaPlay", id], {});
export const getMockAddress = (state: RootState): TeliaPlayState["mockAddress"] =>
    state.config?.environment === "at" ? (getTeliaPlayData(state)?.mockAddress ?? null) : null;
